module.exports = __webpack_public_path__ + "static/img/pic_uavargument.eef256fa.png";